import { fontSize, fontWeight, gutter } from "@app/styles/helpers/theme";

import { css } from "styled-components";

export const headings = css`
    h1 {
        color: var(--dit-layout-color-heading-1--map);
        font-family: var(--dit-layout-font-family-heading-1--map);
        font-size: var(--dit-layout-font-size-heading-1--map);
        font-weight: var(--dit-layout-font-weight-heading-1--map);
        line-height: var(--dit-layout-font-lineHeight-heading-1--map);
        letter-spacing: var(--dit-layout-font-letterSpacing-heading-1--map);
        text-transform: var(--dit-layout-font-textTransform-heading-1--map);
        font-variant: var(--dit-layout-font-variant-heading-1--map);
    }

    h2 {
        color: var(--dit-layout-color-heading-2--map);
        font-family: var(--dit-layout-font-family-heading-2--map);
        font-size: var(--dit-layout-font-size-heading-2--map);
        font-weight: var(--dit-layout-font-weight-heading-2--map);
        line-height: var(--dit-layout-font-line-height-heading-2--map);
        letter-spacing: var(--dit-layout-font-letterSpacing-heading-2--map);
        text-transform: var(--dit-layout-font-textTransform-heading-2--map);
        font-variant: var(--dit-layout-font-variant-heading-2--map);

        &.widget {
            padding: ${gutter(0.5)} ${gutter()};
        }
    }

    h3 {
        color: var(--dit-layout-color-heading-3--map);
        font-family: var(--dit-layout-font-family-heading-3--map);
        font-size: var(--dit-layout-font-size-heading-3--map);
        font-weight: var(--dit-layout-font-weight-heading-3--map);
    }

    h6 {
        color: var(--dit-layout-color-heading-6--map);
        font-family: var(--dit-layout-font-family-heading-6--map);
        font-size: var(--dit-layout-font-size-heading-6--map);
        font-weight: var(--dit-layout-font-weight-heading-6--map);

        /* TODO: in DDC ? remove */
        &.widget {
            font-size: ${fontSize(16)};
            text-transform: uppercase;
            padding: ${gutter(0.5)} ${gutter()};
        }
    }

    :is(h1, h2, h3, h4, h5, h6) {
        .emphasis,
        strong {
            font-weight: ${fontWeight("bold")};
            color: inherit;
        }

        a,
        a:not([href]):not([tabindex]) {
            color: var(--dit-layout-color-link--map);
            font-size: var(--dit-layout-font-size-link--map);
            font-weight: var(--dit-layout-font-size-weight--map);
        }

        a:hover,
        a:not([href]):not([tabindex]):hover {
            color: var(--dit-layout-color-link-hover--map);
            text-decoration: underline;
        }

        a:visited,
        a:not([href]):not([tabindex]):visited {
            color: var(--dit-layout-color-link-visited--map);
        }

        a:focus-visible {
            box-shadow: var(--dit-layout-shadow-link-focus--map);
        }

        small {
            font-size: ${fontSize(12)};
        }
    }
`;
